import registerComment from '../../../common/comments/index';
import presentationalComponent from './CommentThread';
import containerComponent from './CommentThreadContainer';

import { TOOLS } from '../../workspace/toolbar/toolbarConstants';

export default () =>
    registerComment({
        containerComponent,
        presentationalComponent,
        tools: [TOOLS.RICH_TEXT, TOOLS.COLOR, TOOLS.COLLAPSE],
    });
